<template>
    <slot name="breadcrumb"></slot>
    <section class="position-relative overflow-x-clip overflow-y-clip">
        <div class="position-absolute start-0 bg-slash-1"></div>
        <div class="position-absolute end-0 bg-slash-2"></div>

        <div class="container py-5 position-relative">
            <div class="position-absolute start-0 bg-slash-3"></div>

            <div class="row justify-content-center">
                <div class="col-sm-8 col-md-6 col-lg-5 col-xl-4">
                    <slot></slot>
                </div>

            </div>
        </div>
    </section>

</template>

<script>
import Breadcrumb from "../Components/Breadcrumb";

export default {
    components: {
        Breadcrumb,
    }
}
</script>

<style scoped>

</style>
